import React from 'react';
import classes from './Grid.module.scss';


export const Grid = ({ children }) => {
    return (
        <div className={classes.Grid}>
            { children }
        </div>
    )
}